import gql from 'graphql-tag';

/**
 * This used to use the non-experimental Query.quickReload, but we switched
 * back to REST to save on load for the GraphQL servers. To minimize code
 * rewrites, the query structure was largely kept intact, with the experimental
 * resolver performing the reformatting.
 */
export const QuickReloadQuery = gql`
	query QuickReloadQuery($contentId: ID!, $since: ExperimentalLong!) @experimental {
		experimentalQuickReload(contentId: $contentId, since: $since) {
			time
			editorForPage {
				displayName
				accountId
			}
			comments {
				comment {
					id
					url
					author {
						displayName
						accountId
					}
				}
			}
		}
	}
`;
